import { RootState } from '@core/store/rootReducer';
import { createSelector } from '@reduxjs/toolkit';

const preferencesState = (state: RootState) => state.preferences;

export const selectPreferencesState = createSelector([preferencesState], (state) => ({
  ...state,
  loading: state.loadingPending > 0,
}));

export const selectPreferencesLoading = createSelector([preferencesState], (state) => state.loadingPending > 0);
